export default __webpack_public_path__ + "static/media/Fine thankyou.83438062.mp3";